module.exports = __webpack_public_path__ + "static/bg2-5549f70a0154f3ed8096965ccb337535.jpg";